// src/components/SalaOnline.jsx
import React, { useState } from "react";
import { ref, remove } from "firebase/database";
import { db } from "../firebase";
import "./SalaOnline.css";

function SalaOnline({ sala, codigoSala, miNombre, jugadores, onSalir, handleEmpezarPartida }) {
  const [copiado, setCopiado] = useState(false);

  // Solo el creador puede expulsar
  const esCreador = sala?.creador === miNombre;

  // Copiar código de sala
  const copiarCodigo = () => {
    navigator.clipboard.writeText(codigoSala);
    setCopiado(true);
    setTimeout(() => setCopiado(false), 1100);
  };

  // Expulsar jugador
  const expulsarJugador = nombre => {
    if (window.confirm(`¿Seguro que quieres expulsar a ${nombre}?`)) {
      remove(ref(db, `salas/${codigoSala}/jugadores/${nombre}`));
    }
  };

  // Mostrar botón de empezar solo si eres el creador y hay 2+
  const puedeEmpezar = esCreador && jugadores.length >= 2;

  return (
    <div className="salaonline-panel">
      <h2>
        Sala: <span className="codigo-sala">{codigoSala}</span>
        <button className="btn-copiar-codigo" onClick={copiarCodigo}>
          {copiado ? "¡Copiado!" : "📋"}
        </button>
      </h2>
      <p className="sala-msg">Comparte el código con tus amigos para que se unan.<br />
        <span className="yo-mismo">Tú eres: <b>{miNombre}</b></span>
        {esCreador && <span className="emoji-crown">👑 (Creador)</span>}
      </p>

      <div className="jugadores-lista-box">
        <h3>Jugadores en la sala:</h3>
        <ul className="lista-jugadores">
          {jugadores.map(j => (
            <li key={j.nombre} className={j.nombre === miNombre ? "yo-mismo" : ""}>
              {j.nombre}
              {j.nombre === sala?.creador && <span className="emoji-crown">👑</span>}
              {esCreador && j.nombre !== miNombre && (
                <button
                  className="btn-expulsar"
                  onClick={() => expulsarJugador(j.nombre)}
                  title="Expulsar jugador"
                >✖</button>
              )}
            </li>
          ))}
        </ul>
      </div>

      <div className="sala-botones">
        <button className="btn-volver" onClick={onSalir}>Salir de la sala</button>
        {puedeEmpezar ? (
          <button className="btn-jugaronline" onClick={handleEmpezarPartida}>Empezar partida</button>
        ) : (
          <div className="msg-esperando">
            {esCreador
              ? "Debes esperar a que haya al menos 2 jugadores"
              : "Esperando a que el creador empiece la partida..."}
          </div>
        )}
      </div>
    </div>
  );
}

export default SalaOnline;
